import { render, staticRenderFns } from "./orderTablePage.vue?vue&type=template&id=09e0bad8&scoped=true&"
import script from "./orderTablePage.vue?vue&type=script&lang=js&"
export * from "./orderTablePage.vue?vue&type=script&lang=js&"
import style0 from "./orderTablePage.vue?vue&type=style&index=0&id=09e0bad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0bad8",
  null
  
)

export default component.exports